import React from 'react';
import { Box } from '@chakra-ui/react';
import merge from 'deepmerge';

import ButtonGroup from '../../../components/Modal/ModalButtonGroups/ButtonGroup';
import StackedButtonGroup from '../../../components/Modal/ModalButtonGroups/StackedButtonGroup';
import { debounceAction } from '../../../utils/debounce';

export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
export const UPDATE_MODAL_OPTIONS = 'UPDATE_MODAL_OPTIONS';
export const MODAL_GO_BACK = 'MODAL_GO_BACK';

export const showConfirmModal = debounceAction((title, onConfirm) => dispatch => {
  dispatch({
    type: SHOW_MODAL,
    isOpen: true,
    component: (...props) => <Box {...props} />,
    options: {
      title,
      buttons: {
        component: ButtonGroup,
        primaryButtonOptions: { onClick: onConfirm }
      }
    },
    props: {}
  });
});

export const showModal = debounceAction((component, options = {}, props = {}) => dispatch => {
  dispatch({
    type: SHOW_MODAL,
    isOpen: true,
    component,
    options,
    props
  });
});

export const hideModal = debounceAction(() => dispatch => {
  dispatch({ type: HIDE_MODAL, isOpen: false });
});

export const modalGoBack = () => dispatch => {
  dispatch({ type: MODAL_GO_BACK });
};

export const updateModalOptions = options => dispatch => {
  dispatch({ type: UPDATE_MODAL_OPTIONS, options });
};

const DefaultState = {
  previousState: null,
  options: {
    actionRequired: false,
    withHistory: false,
    center: true,
    size: 'sm',
    title: null,
    onClose: () => {},
    variant: '',
    borderProps: {},
    buttons: {
      component: '',
      componentOptions: {},
      primaryButtonOptions: {
        label: 'Confirm',
        type: 'button',
        onClick: () => {},
        formId: null,
        dataAnalyticsId: '',
        isLoading: false
      },
      secondaryButtonOptions: { secondaryLabel: 'Cancel' },
      withHistoryButton: false
    }
  },
  isOpen: false,
  component: null,
  props: {}
};

const modalReducer = (state = DefaultState, action) => {
  switch (action.type) {
    case SHOW_MODAL: {
      const { options, ...rest } = action;
      let previousState = null;

      if (options.withHistory) {
        previousState = { ...state };
      }

      const newOptions = {
        ...DefaultState.options,
        ...options,
        actions: {
          ...DefaultState.options.actions,
          ...(options.actions || {})
        }
      };

      return {
        ...state,
        ...rest,
        options: newOptions,
        previousState
      };
    }

    case HIDE_MODAL:
      return { ...DefaultState, isOpen: action.isOpen };

    case MODAL_GO_BACK:
      return { ...state.previousState };

    case UPDATE_MODAL_OPTIONS:
      return {
        ...state,
        options: merge(state.options, action.options)
      };

    default:
      return state;
  }
};

export default modalReducer;

export const selectModalOpen = state => state.modal.isOpen;
export const selectModalData = state => state.modal.options;
export const selectModalProps = state => state.modal.props;
export const selectModalComponent = state => state.modal.component;
export const selectModalPreviousState = state => state.modal.previousState;
export const selectModalOnClose = state => state.modal.options.onClose;
export const selectModalButtons = state => state.modal.options.buttons;
